import { Injectable } from '@angular/core';
import { SupabaseDatabaseService } from './supabase-database.service';
import TYPES from '../constants/types';

@Injectable({
  providedIn: 'root',
})
export class AppointmentService <Appointment> extends SupabaseDatabaseService<Appointment> {
  
  async getAllAppointmentByPsychologistId(psychologistId: string): Promise<Appointment[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.APPOINTMENTS)
    .select(`
      *,
      users(
        id,
        first_name,
        last_name,
        email
      ),
      psychologists(
        id,
        first_name,
        last_name
      )
    `)
    .eq('psychologist_id', psychologistId);

    if (error) {
      console.error(`Erro ao buscar appointments pelo psychologistId '${psychologistId}' em '${TYPES.DATABASE.TABLES.APPOINTMENTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as Appointment[]) || [];

  }

  async getAllAppointmentByUserId(userId: string): Promise<Appointment[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.APPOINTMENTS)
    .select(`
      *,
      users(
        id,
        first_name,
        last_name,
        email
      ),
      psychologists(
        id,
        first_name,
        last_name
      )
    `)
    .eq('user_id', userId);

    if (error) {
      console.error(`Erro ao buscar appointments pelo userId '${userId}' em '${TYPES.DATABASE.TABLES.APPOINTMENTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as Appointment[]) || [];

  }

  async getAllPendingAppointmentByUserId(userId: string): Promise<Appointment[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.APPOINTMENTS)
    .select(`
      *,
      users(
        id,
        first_name,
        last_name,
        email
      ),
      psychologists(
        id,
        first_name,
        last_name
      )
    `)
    .eq('user_id', userId)
    .eq('status', TYPES.DATABASE.STATUS.WAITING_CONFIRMATION.code);

    if (error) {
      console.error(`Erro ao buscar pending appointments pelo userId '${userId}' em '${TYPES.DATABASE.TABLES.APPOINTMENTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as Appointment[]) || [];

  }

  async getConfirmedAppointmentsByPsychologistPatientAndDateRange(
    psychologistId: string,
    userId: string,
    startIso: string,
    endIso: string
  ): Promise<Appointment[]>{
    const { data, error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.APPOINTMENTS)
      .select(`
        *,
        users(
          id,
          first_name,
          last_name,
          email
        ),
        psychologists(
          id,
          first_name,
          last_name
        )
      `)
      .eq('psychologist_id', psychologistId)
      .eq('user_id', userId)
      .eq('status', TYPES.DATABASE.STATUS.CONFIRMED.code)
      .gte('date', startIso)
      .lte('date', endIso)
      .order('date', { ascending: true });

    if (error) {
      console.error(
        `Erro ao buscar appointments confirmados por psychologistId '${psychologistId}', userId '${userId}' em '${TYPES.DATABASE.TABLES.APPOINTMENTS}':`,
        error
      );
      throw new Error(error.message);
    }

    return (data as Appointment[]) || [];
  }

}
